export { MediaStore, MediaStoreError, isMediaStoreError, getMediaEnvironment, getMediaRegion } from './client/media-store';
export { UploadController } from './upload-controller';
export { isPreviewableType } from './models/media';
export { getArtifactUrl } from './models/artifacts';
export { isMediaClientError, getMediaClientErrorReason } from './models/errors';
export { isUploadingFileState, isProcessingFileState, isProcessedFileState, isErrorFileState, isPreviewableFileState, isFinalFileState, isImageRepresentationReady, mapMediaFileToFileState, mapMediaItemToFileState } from './models/file-state';
export { uploadFile } from './uploader';
export { request, RequestError, isRequestError, isRateLimitedError, createRequestErrorReason } from './utils/request';
export { isAbortedRequestError, mapResponseToJson, mapResponseToBlob, mapResponseToVoid, createUrl } from './utils/request/helpers';
export { PollingFunction } from './utils/polling';
export { isPollingError, PollingError } from './utils/polling/errors';
export { imageResizeModeToFileImageMode } from './utils/imageResizeModeToFileImageMode';
export { FileFetcherImpl, FileFetcherError, isFileFetcherError } from './client/file-fetcher';
export { MediaClient } from './client/media-client';
export { StargateClient } from './client/stargate-client';
export { isImageRemote } from './utils/isImageRemote';
export { checkWebpSupport } from './utils/checkWebpSupport';
export { getDimensionsFromBlob } from './utils/getDimensionsFromBlob';
export { createMediaSubject } from './utils/createMediaSubject';
export { safeUnsubscribe } from './utils/safeUnsubscribe';
export { isFileIdentifier, isExternalImageIdentifier, isDifferentIdentifier } from './identifier';
export { withMediaClient, getMediaClient } from './utils/with-media-client-hoc';
export { globalMediaEventEmitter } from './globalMediaEventEmitter';
export { isMediaBlobUrl, getAttrsFromUrl, addFileAttrsToUrl, objectToQueryString } from './utils/url';
export { createMediaSubscribable, fromObservable } from './utils/mediaSubscribable';
export { RECENTS_COLLECTION, MAX_RESOLUTION } from './constants';

// TODO MEX-659 Remove these exports when all the usages from media-client are replaced with media-common.

import { getMediaTypeFromMimeType as _getMediaTypeFromMimeType, isImageMimeTypeSupportedByBrowser as _isImageMimeTypeSupportedByBrowser, isDocumentMimeTypeSupportedByBrowser as _isDocumentMimeTypeSupportedByBrowser, isMimeTypeSupportedByBrowser as _isMimeTypeSupportedByBrowser, isImageMimeTypeSupportedByServer as _isImageMimeTypeSupportedByServer, isDocumentMimeTypeSupportedByServer as _isDocumentMimeTypeSupportedByServer, isAudioMimeTypeSupportedByServer as _isAudioMimeTypeSupportedByServer, isVideoMimeTypeSupportedByServer as _isVideoMimeTypeSupportedByServer, isUnknownMimeTypeSupportedByServer as _isUnknownMimeTypeSupportedByServer, isMimeTypeSupportedByServer as _isMimeTypeSupportedByServer } from '@atlaskit/media-common/mediaTypeUtils';

/**
 * @deprecated This export will be removed. Please use one from @atlaskit/media-common or @atlaskit/media-common/mediaTypeUtils
 */
export var getMediaTypeFromMimeType = _getMediaTypeFromMimeType;
/**
 * @deprecated This export will be removed. Please use one from @atlaskit/media-common or @atlaskit/media-common/mediaTypeUtils
 */
export var isImageMimeTypeSupportedByBrowser = _isImageMimeTypeSupportedByBrowser;
/**
 * @deprecated This export will be removed. Please use one from @atlaskit/media-common or @atlaskit/media-common/mediaTypeUtils
 */
export var isDocumentMimeTypeSupportedByBrowser = _isDocumentMimeTypeSupportedByBrowser;
/**
 * @deprecated This export will be removed. Please use one from @atlaskit/media-common or @atlaskit/media-common/mediaTypeUtils
 */
export var isMimeTypeSupportedByBrowser = _isMimeTypeSupportedByBrowser;
/**
 * @deprecated This export will be removed. Please use one from @atlaskit/media-common or @atlaskit/media-common/mediaTypeUtils
 */
export var isImageMimeTypeSupportedByServer = _isImageMimeTypeSupportedByServer;
/**
 * @deprecated This export will be removed. Please use one from @atlaskit/media-common or @atlaskit/media-common/mediaTypeUtils
 */
export var isDocumentMimeTypeSupportedByServer = _isDocumentMimeTypeSupportedByServer;
/**
 * @deprecated This export will be removed. Please use one from @atlaskit/media-common or @atlaskit/media-common/mediaTypeUtils
 */
export var isAudioMimeTypeSupportedByServer = _isAudioMimeTypeSupportedByServer;
/**
 * @deprecated This export will be removed. Please use one from @atlaskit/media-common or @atlaskit/media-common/mediaTypeUtils
 */
export var isVideoMimeTypeSupportedByServer = _isVideoMimeTypeSupportedByServer;
/**
 * @deprecated This export will be removed. Please use one from @atlaskit/media-common or @atlaskit/media-common/mediaTypeUtils
 */
export var isUnknownMimeTypeSupportedByServer = _isUnknownMimeTypeSupportedByServer;
/**
 * @deprecated This export will be removed. Please use one from @atlaskit/media-common or @atlaskit/media-common/mediaTypeUtils
 */
export var isMimeTypeSupportedByServer = _isMimeTypeSupportedByServer;